import parseNumber from "./util/parseNumber";

/**
 * Transforms a single question's answers to the expected format
 * @param {Array | string} answers Questions with details from the API
 * @param {string} type ex. CURRENCY or CHECKBOX
 * @returns {Array} An array of objects with values
 */
var transformAnswersForQuestion = function transformAnswersForQuestion(_ref) {
  var answers = _ref.answers,
    type = _ref.type;
  if (typeof answers === "string") {
    var castAnswer = answers;
    if (type === "CURRENCY") {
      castAnswer = parseNumber(answers);
    }
    return [{
      value: castAnswer
    }];
  }
  return answers.reduce(function (array, answer) {
    array.push({
      value: answer
    });
    return array;
  }, []);
};

/**
 * Transforms user submitted answers to the expected format
 * @param {Array} questions Questions with details from the API
 * @param {Object} userResponse User submitted answers to questions
 * @returns {Array} An array with an optional user_response object
 */
var transformQuestionResponses = function transformQuestionResponses(questions, userResponse) {
  return questions.reduce(function (transformedResponse, question) {
    if (question.type === "INSTRUCTIONS") {
      return transformedResponse;
    }
    var answers = userResponse[question.alias];
    transformedResponse.push({
      alias: question.alias,
      type: question.type,
      answers: transformAnswersForQuestion({
        answers: answers,
        type: question.type
      })
    });
    return transformedResponse;
  }, []);
};
export default transformQuestionResponses;